import React, { FC } from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import ClockSVG from './assets/clock.svg';

interface TimeToReadProps {
  timeToRead: number;
}

const TimeToRead: FC<TimeToReadProps> = ({ timeToRead }) => (
  <>
    <img src={ClockSVG} alt="" />
    {/* @TODO - add plural forms */}
    <I18n k="fiverr_guides.reading_time" params={{ time: timeToRead }} />
  </>
);

export default TimeToRead;
